import { render, staticRenderFns } from "./ProfileDashboardTab.vue?vue&type=template&id=7e522610&"
import script from "./ProfileDashboardTab.vue?vue&type=script&lang=js&"
export * from "./ProfileDashboardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports